// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"65dfbdf1","359":"c908f7ca","563":"cba7a44d","576":"e9c1a3d7","671":"34e8a2e0","683":"3d5758f3","769":"f3c433af","787":"44f5ae0a","863":"42eb6aa1","954":"c6337449"}[chunkId] + ".chunk.js";
};